export const environment = {
	name: "dev",
	servicesUrl: "https://preprod.api.legend-binder.com/services",
	imgUrl: "https://preprod.api.legend-binder.com/img",
	stripKey: "pk_test_51T5wuNPYsGW26rDcVaeCgYY9MqosB6NSh3jE2hNHAK7C67EIEEohZPaT4Yeec1WG5s9UuKPHJDNpiCGW3636tMpy00zBvHfDg3"
};
